<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.changeOrderStatus === 'D' || row.changeOrderStatus === 'R'
              ? 'warning'
              : row.changeOrderStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_changeOrderStatus }}
        </el-tag>
      </template>
      <template v-slot:oldOrderAmountInfo="{ row }">
        <span> {{ row.v_oldOrderAmount }} {{ row.v_oldCurrencyUnit }}</span>
      </template>
      <template v-slot:newOrderAmountInfo="{ row }">
        <span> {{ row.v_newOrderAmount }} {{ row.v_newCurrencyUnit }}</span>
      </template>
      <template v-slot:oldOrderSalesAmountInfo="{ row }">
        <span>
          {{ row.v_oldOrderSalesAmount }} {{ row.v_oldSalesCurrencyUnit }}</span
        >
      </template>
      <template v-slot:newOrderSalesAmountInfo="{ row }">
        <span>
          {{ row.v_newOrderSalesAmount }} {{ row.v_newSalesCurrencyUnit }}</span
        >
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.changeOrderCode },
                  query: { changeOrderNo: row.changeOrderNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_audit') || '审核'"
            placement="top"
            v-if="allow('F')"
          >
            <i
              class="el-icon-s-check tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.changeOrderCode },
                  query: { changeOrderNo: row.changeOrderNo },
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'order-changeOrderConfirmDetail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
